import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { word } from "@modules/core/utils/i18n"
import { formatCurrency, getCurrencySymbol } from "@modules/currency/currency"
import { getFormatedDateTime } from "@modules/language/languageUtils"

export const getFormattedPromoCodeReduction = (
  promoCodeType: CouponType,
  promoCodeValue: number,
  locale: string,
  currency?: string,
): string => {
  if (promoCodeType === CouponType.DIRECT) {
    return `- ${formatCurrency(promoCodeValue, currency, locale)}`
  } else {
    return `- ${promoCodeValue.toString()}%`
  }
}

export const getFormattedPromoCodeExpiration = (expirationDate?: Date): string => {
  return expirationDate
    ? getFormatedDateTime(expirationDate, { mode: "date" })
    : word("promoCode.view.noExpirationDate")
}

export const getFormattedPromoCodeStartAt = (startAt: Date | null, createdAt: Date): string => {
  return startAt ? getFormatedDateTime(startAt, { mode: "date" }) : getFormatedDateTime(createdAt, { mode: "date" })
}

export const getFormattedPromoCodeDuration = (durationInMonths: number | null): string => {
  return durationInMonths ? `${durationInMonths.toString()} months` : word("promoCode.view.unlimited")
}

export const getReducedProgramPrice = (
  programPrice: PriceObjectEntity,
  promoCodeValue?: number,
  promoCodeType?: CouponType,
): PriceObjectEntity => {
  let resultingPrice = 0

  if (promoCodeType && promoCodeValue) {
    if (promoCodeType === CouponType.PERCENT) resultingPrice = (programPrice.value * (100 - promoCodeValue)) / 100
    else {
      if (promoCodeValue >= programPrice.value) resultingPrice = 0
      else resultingPrice = programPrice.value - promoCodeValue
    }
  }

  return PriceObjectEntity.fromDto({
    value: resultingPrice,
    currency: programPrice.currency,
  })
}

export const getFormattedReductedProgramPrice = (
  locale: string,
  programPrice: PriceObjectEntity | null,
  promoCodeValue?: number,
  promoCodeType?: CouponType,
  defaultCurrency?: string,
): string => {
  if (!programPrice) return `-- ${getCurrencySymbol(defaultCurrency, locale)}`

  const reducedProgramPrice = getReducedProgramPrice(programPrice, promoCodeValue, promoCodeType)
  return formatCurrency(reducedProgramPrice.value, reducedProgramPrice.currency, locale)
}
